module.exports = __webpack_public_path__ + "assets/img/acoucou_logo.svg";